 $(document).ready(function() {
   $('ul li').hover(function(){
     $('.header-main-menu-link-list-sub-dropdowns li').removeClass('mega-toggle-on');
   });
    $("#myPopup").css("display", "none"); // Hide the popup initially

    $("#customPackagingTrigger").click(function() {
      $("#myPopup").css("display", "block");
    });

    $("#customPackagingTriggerquote").click(function() {
      $("#myPopup").addClass("show");
    });
   
    $("#showPopup").click(function() {
      $("#myPopup").addClass("show");
    });

    $("#close-qq-popup").click(function() {
      $("#myPopup").removeClass("show");
      $("#myPopup").css("display", "none");
    });

  
  });